import { filter, get } from 'lodash';

export const getApplicationsForZoneByType = ({ zone, applicationType}) => {
  return get(zone, `meta.applications.${applicationType}`, []);
};

export const getApplicationsForZone = (zone) => {
  return get(zone, `meta.applications`, {});
};

export const getApplicationsByType = ({ zones, applicationType }) => {
  if (!zones) { return []; }

  return Object.values(zones).map((zone) => {
    return getApplicationsForZoneByType({ zone, applicationType });
  });
};

export const getZonesArray = (zones) => {
  return zones ? Object.keys(zones).map(zoneId => zones[zoneId]) : [];
};

export const getApplicationRateUnitForZoneByType = ({zone, applicationType}) => {
  const applications = getApplicationsForZoneByType({zone, applicationType});
  return applications.length > 0 ? applications[0].rate.u : null;
};

export const getApplicationRateUnitByType = ({ zones, applicationType }) => {
  const zonesArray = getZonesArray(zones);
  return zonesArray.length > 0 ? getApplicationRateUnitForZoneByType({zone:zonesArray[0], applicationType}) : null;
};

export const getZonesArrayWithIds = ({ zones, zoneIds }) => {
  return getZonesArray(zones).filter(zone => zoneIds.indexOf(zone.meta.zoneId) !== -1);
};

export const getLastZoneId = (zones) => {
  const zonesArray = getZonesArray(zones);
  let lastZoneId = null, highestIndex = -1;
  zonesArray.forEach(zone => {
    const zoneIndex = get(zone, 'meta.index');
    if (zoneIndex > highestIndex) {
      highestIndex = zoneIndex;
      lastZoneId = get(zone, 'meta.zoneId');
    }
  });
  return lastZoneId;
};

export const getSoilCompositionForZone = (zone) => {
  return get(zone, `meta.soilComposition`, []);
};

export const getApplicationsWithNumericalRate = (applications) => {
  return filter(applications, (application) => {
    const rate = get(application[0], 'rate');
    return Number.isFinite(get(rate, 'q'));
  });
};
